/* eslint-disable no-shadow */
const state = {
	shippingCharge: {
		type: Number,
		default: 0.0
	},
	tax: {
		type: Number,
		default: 0.0
	},
	showChargeData: {
		type: Boolean,
		default: false
	}
}

const getters = {
	getShippingCharge: state => state.shippingCharge,
	getTaxCharge: state => state.tax,
	isShowCharge: state => state.showChargeData
}

const mutations = {
	setShippingChargeMutation: (state, payload) => {
		state.shippingCharge = payload
	},
	setTaxMutation: (state, payload) => {
		state.tax = payload
	},
	setShowChargeMutation: (state, payload) => {
		state.showChargeData = payload
	}
}

const actions = {
	setShippingCharge: ({ commit }, payload) => {
		commit('setShippingChargeMutation', payload)
	},
	setTax: ({ commit }, payload) => {
		commit('setTaxMutation', payload)
	},
	setShowCharge: ({ commit }, payload) => {
		commit('setShowChargeMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
